<p-toast position="top-right" styleClass="toast">
  <ng-template let-message pTemplate="message">
    <div
      class="flex items-center h-full w-full p-3 cursor-pointer select-none rounded-xl border"
      [class]="message.contentStyleClass"
    >
      <l-icon class="text-lWhite !text-3xl mr-3 shrink-0" [icon]="message.icon" />

      <div class="min-w-0">
        <h3 class="text-sm flex text-lWhite font-semibold">
          {{ message.summary }}
        </h3>
        <p class="text-sm text-lGray300">
          {{ message.detail }}
        </p>
      </div>
    </div>
  </ng-template>
</p-toast>
